import { NotificationConfig, NotificationData } from '@hypergraph/tapestry';

export enum ApplicationMessageType {
  SUCCESS,
  ERROR,
  INFO,
}

export interface IApplicationMessage {
  id: string;
  title: string;
  message: string;
  type: ApplicationMessageType;
}

export interface QueuedNotification {
  id: string;
  data: NotificationData;
  config: Partial<NotificationConfig>;
}
